import links from "@/links/links";

export default {
  actions: {
    FETCH(buildingId) {
      return this.get(links.BUILDING_LOT_FETCH(buildingId), {
        dataKey: "hydra:member",
      });
    },
  },
};
